import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const HamburguerSvg = () => (
  <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.866211 13.7101H20.038V17.8134H0.866211V13.7101Z" fill="currentColor" />
    <path d="M0.866211 6.87091H20.038V10.9742H0.866211V6.87091Z" fill="currentColor" />
    <path d="M0.866211 0.0327148H20.038V4.13603H0.866211V0.0327148Z" fill="currentColor" />
  </svg>
);

const HamburguerMenu = (props: IIconProps) => <Icon component={HamburguerSvg} {...props} />;

export default HamburguerMenu;
